export function Logo({ className = "", onClick }) {
  return (
    <div className={`flex items-center gap-2 select-none ${className}`} onClick={onClick} data-testid="urlifa-logo">
      <div className="h-8 w-8 rounded-xl bg-primary flex items-center justify-center text-primary-foreground font-display font-bold text-lg">U</div>
      <span className="font-display font-bold text-xl tracking-tight">URLIFA</span>
    </div>
  );
}
